import Page from 'routes/SearchGCSE'

const Home = () => <Page />

export default Home
